module.exports = {
	RECEIVE_DETAIL_STATION: 'RECEIVE_DETAIL_STATION',
	RECEIVE_DETAIL_QUALITO: 'RECEIVE_DETAIL_QUALITO',
	RECEIVE_DETAIL_PICKUP_OPERATION: 'RECEIVE_DETAIL_PICKUP_OPERATION',
	RECEIVE_DETAIL_PIEZOMETER_MEASURE: 'RECEIVE_DETAIL_PIEZOMETER_MEASURE',
	RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MAX: 'RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MAX',
	RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MIN: 'RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MIN',
	RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MOYENNE: 'RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MOYENNE',
	RECEIVE_DETAIL_STATION_NETWORK: 'RECEIVE_DETAIL_STATION_NETWORK',
	RECEIVE_DETAIL_QUALITO_SAMPLING_SURFACE_POINT: 'RECEIVE_DETAIL_QUALITO_SAMPLING_SURFACE_POINT',
	ADD_QUALITOMETER_DETAIL_ANALYSIS: 'ADD_QUALITOMETER_DETAIL_ANALYSIS',
	DETAIL_STATION_RESET: 'DETAIL_STATION_RESET',
	RECEIVE_INDUSTRIAL_SEVESO: 'RECEIVE_INDUSTRIAL_SEVESO',
	RECEIVE_INDUSTRIAL_ACTIVITY: 'RECEIVE_INDUSTRIAL_ACTIVITY',
	RECEIVE_INDUSTRIAL_FAMILY: 'RECEIVE_INDUSTRIAL_FAMILY',
	RECEIVE_DETAIL_INDUSTRIAL: 'RECEIVE_DETAIL_INDUSTRIAL',
	RECEIVE_DETAIL_POLLUTED_SOIL: 'RECEIVE_DETAIL_POLLUTED_SOIL',
	RECEIVE_ICPE_ACTIVITY: 'RECEIVE_ICPE_ACTIVITY',
	PANEL_DASHBOARD: 'PANEL_DASHBOARD',
	PANEL_DETAIL: 'PANEL_DETAIL'
}



// WEBPACK FOOTER //
// ./src/station/constants/DetailStationConstants.js